import React from 'react'

const Partner = ({ src, title, link }) => (
    <div className={'partner'}>
        <a title={title} href={link} target="_blank">
            <img src={`/images/partners/${src}`} alt />
        </a>
    </div>
);

export default Partner;
